module.exports = __webpack_public_path__ + "static/media/reject-btn.3ec41052.svg";